// copy of regexutils in adhublib
const REGEX_META_CHARS = /[\x2d$(-+.?[-^{-}]/g;

// The /u flag is more strict about superfluous escaping, and only allows
// escaped hyphen in character classes. Using the \xXX escape is allowed in
// all contexts.
//
const NEEDS_HEX_ESCAPE = new Set(['-']);

/**
 * Escapes a string for RegExp syntax.
 *
 * The resulting string can be used as a regular expression that matches
 * the literal input string.
 */
export function escape(literalString: string): string {
    return literalString.replace(REGEX_META_CHARS, (match) => {
        if (NEEDS_HEX_ESCAPE.has(match)) {
            const code = match.codePointAt(0)!.toString(16);
            return `\\x${code.padStart(2, '0')}`;
        }
        return `\\${match}`;
    });
}
